import { Box, Group, Stack } from '@mantine/core';
import { formatDate } from '../../../../../../helpers/date-time-helpers';
import { useTargetsTabStore } from '../../../../../../store/strategy-store/strategy-store';
import { Text } from '../../../../../../ui-library/typography/typography';
import { getMeasureDataTypesColors, getMeasureDataTypesLabel } from '../../targets-tab.helpers';
import { MeasureDataType } from '../../targets-tab.type';
import { formatChartValue } from './targets-chart.helpers';

export const TargetsChartTooltip = (props: any) => {
  const { active, payload, label } = props;
  const selectedTarget = useTargetsTabStore((state) => state.selectedTarget);

  if (!active || !payload || !payload.length || !label) {
    return null;
  }

  const measureDataTypesColors = getMeasureDataTypesColors();

  return (
    <Stack
      gap="xs"
      p="xs"
      style={{
        backgroundColor: 'white',
        borderRadius: 4,
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Text size="small" weight="medium">
        {formatDate(label)}
      </Text>

      <Stack gap="xs">
        {payload.map((entry: any, index: any) => {
          const measureName = entry.name as MeasureDataType;
          const measureDataType = Object.values(MeasureDataType).includes(measureName)
            ? measureName
            : MeasureDataType.Actual;
          const label = getMeasureDataTypesLabel(selectedTarget, measureDataType);

          return (
            <Group key={`tooltip-${index}`} justify="space-between" gap={8}>
              <Group gap={8}>
                <Box
                  style={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    backgroundColor: measureDataTypesColors[entry.name as MeasureDataType],
                  }}
                />
                <Text size="small">{label}</Text>
              </Group>
              <Text size="small" weight="medium">
                {formatChartValue(entry.value)}
              </Text>
            </Group>
          );
        })}
      </Stack>
    </Stack>
  );
};
